export const FUNCTIONAL_DIAGRAMS_FLAG = 'functional_diagrams'
export const AUTHORING_TOOLS_FLAG = 'authoring_tools'
